import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { rcApi, errMsg, fmt, thisMonth } from "./rcApi";

export const RiderCashMonthEnd = ({ onChanged }) => {
  const [month, setMonth] = useState(thisMonth());
  const [data, setData] = useState({ rows: [], total: 0 });
  const [sel, setSel] = useState([]);
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => rcApi.monthEnd(month).then((d) => { setData(d); setSel(d.rows.filter((r) => r.has_salary).map((r) => r.employee_id)); }).catch((e) => toast.error(errMsg(e))), [month]);
  useEffect(() => { load(); }, [load]);
  const apply = async () => {
    if (!sel.length) return toast.error("اختر مندوباً واحداً على الأقل");
    if (!window.confirm(`اعتماد خصم النقد غير المورّد من رواتب ${sel.length} مندوب لشهر ${month}؟`)) return;
    setBusy(true);
    try {
      const r = await rcApi.monthApply(month, sel);
      toast.success(`تم الخصم من ${r.applied} راتب بإجمالي ${fmt(r.total)} ريال`);
      if (r.skipped_no_salary?.length) toast.warning(`بدون مسير راتب: ${r.skipped_no_salary.join("، ")}`);
      load(); onChanged();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const toggle = (id) => setSel((s) => (s.includes(id) ? s.filter((x) => x !== id) : [...s, id]));
  return (
    <div className="space-y-4" data-testid="rc-month-end">
      <div className="flex flex-wrap items-end gap-3 rounded-xl border bg-amber-50/60 p-4">
        <div><label className="text-xs text-slate-500">الشهر</label><Input data-testid="rc-month-input" type="month" value={month} onChange={(e) => setMonth(e.target.value)} className="w-44" /></div>
        <p className="text-sm text-slate-600">الإجمالي غير المورّد حتى نهاية الشهر: <b className="text-rose-600" data-testid="rc-month-total">{fmt(data.total)}</b> ريال</p>
        <Button data-testid="rc-month-apply" className="mr-auto bg-amber-600 hover:bg-amber-700" disabled={busy} onClick={apply}>{busy && <Loader2 className="h-4 w-4 animate-spin" />}اعتماد الخصم كـ «عجز نقدي»</Button>
      </div>
      <div className="overflow-x-auto rounded-xl border bg-white">
        <table className="w-full text-right text-sm">
          <thead className="bg-slate-50 text-xs text-slate-500"><tr>{["", "المندوب", "الرصيد المستحق", "المطبّق سابقاً", "مسير الراتب"].map((h, i) => <th key={i} className="p-2 font-medium">{h}</th>)}</tr></thead>
          <tbody>
            {data.rows.map((r) => (
              <tr key={r.employee_id} className="border-t" data-testid={`rc-month-row-${r.employee_id}`}>
                <td className="p-2"><input type="checkbox" disabled={!r.has_salary} checked={sel.includes(r.employee_id)} onChange={() => toggle(r.employee_id)} data-testid={`rc-month-check-${r.employee_id}`} /></td>
                <td className="p-2">{r.name}</td>
                <td className="p-2 font-semibold tabular-nums text-rose-600">{fmt(r.to_deduct)}</td>
                <td className="p-2 tabular-nums">{fmt(r.applied)}</td>
                <td className="p-2 text-xs">{r.has_salary ? <span className="text-emerald-600">موجود</span> : <span className="text-slate-400">غير منشأ</span>}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {!data.rows.length && <p className="p-8 text-center text-sm text-slate-400">لا توجد أرصدة نقد غير مورّدة لهذا الشهر</p>}
      </div>
    </div>
  );
};
